export const RG69_01 = {
    "columns": 12,
    "rows": 2,
    "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": 'colorTheme1',
        "title": "Product Sales Performance",
        "binding": {
            "data": {
                "columns": [
                    {
                        "name": 'Product Name',
                        "columnName": 'ItemName',
                        "width": '200px',
                        "align": "left",
                        "sortable": true,
                        "sum": false,
                    },
                    {
                        "name": 'Actual Sales',
                        "columnName": 'ActualSales',
                        "width": '140px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Share',
                        "columnName": 'ActualShare',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    {
                        "name": 'LY Sales',
                        "columnName": 'LYSales',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Share',
                        "columnName": 'LYShare',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    {
                        "name": 'Growth %',
                        "columnName": 'Growth',
                        "width": '118px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    {
                        "name": 'Target',
                        "columnName": 'TargetSales',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Performance %',
                        "columnName": 'Performance',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    }
                ],
                "title": "ItemName",
                "endpoint": "RG69.1",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "RegionCode", "value": "" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {

                    }
                }
            }
        }
    }
}